<template>
    <a id="my-download" href=""></a>

    <SplashScreen />
    <BrowserModal />
    <NewProject />
    <DialogBox />
    <InfoBox />
    <SwatchEdit />
    <LibraryModal />
    <PaletteBar />
    <TopBar />
    <Coordinates />
    <Rotator />
    <BakeImage />
    <div id="menu" v-show="store.state.currentScreen === 'menu'">
        <Navigation />

        <div id="menu-content-area" class="normal-menu-content">
            <Upgrade />
            <EditProject />
            <Palette />
            <MyProjects />
            <ViewSettings />
            <ExportSettings />
            <HelpArea />
        </div>
    </div>

    <div
        id="my-phaser-container"
        :class="getPhaserContainerClass"
    >
        <div id="phaser-div"></div>
    </div>
</template>

<script>
import SplashScreen from './components/SplashScreen.vue';
import BrowserModal from './components/BrowserModal.vue';
import BakeImage from './components/BakeImage.vue';
import DialogBox from './components/DialogBox.vue';
import SwatchEdit from './components/SwatchEdit.vue';
import LibraryModal from './components/LibraryModal.vue';
import InfoBox from './components/InfoBox.vue';
import PaletteBar from './components/PaletteBar.vue';
import TopBar from './components/TopBar.vue';
import Rotator from './components/Rotator.vue';
import Coordinates from './components/Coordinates.vue';

import Navigation from './components/menu/Navigation.vue';
import Upgrade from './components/menu/Upgrade.vue';
import NewProject from './components/menu/NewProject.vue';
import EditProject from './components/menu/EditProject.vue';
import Palette from './components/menu/Palette.vue';
import MyProjects from './components/menu/MyProjects.vue';
import ViewSettings from './components/menu/ViewSettings.vue';
import ExportSettings from './components/menu/ExportSettings.vue';
import HelpArea from './components/menu/HelpArea.vue';

export default {
    name: 'App',
    components: {
        SplashScreen, BrowserModal, BakeImage, DialogBox, SwatchEdit, InfoBox,
        NewProject, EditProject, MyProjects, ViewSettings, Palette,
        ExportSettings, HelpArea, Navigation, Upgrade, LibraryModal,
        PaletteBar, TopBar, Rotator, Coordinates
    },
    computed: {
        getPhaserContainerClass: function () {
            return this.store.state.currentScreen === 'my-phaser-container' ?
                'myVisible' :
                'myHidden';
        }
    },
}
</script>

<style lang="scss">
@import './assets/styles.scss';

    .normal-menu-content {
        margin-left: 180px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s ease;
    }

    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
    }

    .myHidden {
        visibility: hidden;
        opacity: 0;
    }

    .myVisible {
        visibility: visible;
    }

</style>
